<script setup lang="ts">
defineProps<{
    items: Dimension[]
}>()

/**
 * Translations.
 */
const { t } = useI18n()
</script>

<template>
    <template v-for="(item, index) in items" :key="item.id">
        <WorldBreadcrumbItem
            :placeholder="t('select-options')"
            :dimension="item"
            :highlight="index === items.length - 1"
        />

        <ChevronRightIcon
            v-if="item?.hasChildren"
            class="text-deep-blue block h-4 flex-shrink-0"
        />
    </template>
</template>
            